<template>
<div>
    <div class="pgemnt-1">
        <div class="tbs">
            <el-table :data="showArr" v-loading="false" style="width: 100%" >
                <el-table-column label="标题" prop="title"> </el-table-column>
                <el-table-column label="栏目" prop="columnName" width="145">
                </el-table-column>
                <el-table-column label="发布者" prop="editor" width="90">
                </el-table-column>
                <el-table-column label="发布时间" prop="publishTime" width="160">
                    <template> </template>
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        {{ scope.row.status | filterStatus() }}
                    </template>
                </el-table-column>
                <el-table-column align="left" width="240" label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" v-if="scope.row.status==2" @click="save_check(scope.row.id,1)"  size="mini">撤回</el-button>
                        <el-button type="danger" v-if="scope.row.status==3" @click="save_check(scope.row.id,1)"  size="mini">下架</el-button>
                        <el-button type="warning" @click="goEdit(scope.row)" :disabled="scope.row.status==2" size="mini">编辑</el-button>
                        <el-button type="danger" @click="delArticle(scope.row.id)" :disabled="scope.row.status!=1" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="params.basePage.no" :page-size="params.basePage.size" layout="total, prev, pager, next" :total="totalElements" :background="false" :hide-on-single-page="true">
                </el-pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    getArticleListByCondition,
    delArticle,
    check
} from '@/api/jingshi';
export default {
    components: {},
    data() {
        return {
            loading: false,
            showArr: [],
            totalElements: 0, //总条数
            params: {
                dto: {
                    columnId: '', // 栏目ID
                    keyword: '', // 关键词
                    status: '', // 1草稿、2待审核、3上线、4退回
                    property: '', // 1推荐属性、2热门属性、3推荐属性
                    class_type: "ArticleListCondition",
                },
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                1: '草稿',
                2: '待审核',
                3: '上线',
                4: '退回'
            };
            return transMap[e];
        }
    },
    methods: {
        // 保存
        save_check(id,status) {
            var vues = this;
            var params = {
                id: id,
                status: status,
            }

            check(params).then(res => {
                console.log(res);
                this.$message.success('操作成功！');
                this.getList();
            })
        },
        search(params) {
            console.log(params);
            if (params) {
                for (let key in params) {
                    if (this.params.dto.hasOwnProperty(key)) {
                        this.params.dto[key] = params[key];
                    }
                }
            }
            console.log(this.params);
            this.getList();
        },
        // 获取文章列表
        getList() {
            var vues = this;
            this.loading = true;
            getArticleListByCondition(this.params).then(res => {
                this.showArr = res.articleLists;
                this.totalElements = res.totalElements;
                // console.log(res);
                // console.log(res.articleLists);
                vues.loading = false;
            })
        },
        // 删除文章列表
        delArticle(id) {
            var param = {
                ids: [id]
            }
            delArticle(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        // 编辑 
        goEdit: function (e) { // 编辑
            var querys = {};
            querys.id = e.id;
            this.$router.push({
                path: 'add_publish',
                query: querys
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.params.basePage.no = val;
            this.getList();
        },
    },
    created: function () {
        this.getList()
    }
}
</script>

<style lang="scss">
.pgemnt-1 {
    padding: 20px;
}

.pgemnt-1-dag table {
    width: 100%;
    margin-top: 12px;
}

.pgemnt-1 .newAdd {
    width: 90px;
}

// 头部样式
.tbs th {
    background-color: #efefef;
}

.tbs {
  
    .pagination {
      background: white;
        text-align: center;
        margin: 0 0px 0 0px;
    }
}

// .el-input__suffix {
//   right: 0px;
//   transition: all 0.3s;
// }
</style>



// WEBPACK FOOTER //
// list.vue?e32f06ba